import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { Dayjs } from "dayjs";
import { Badge } from "../../../../../../../components/badge/Badge";
import { getOrderFulfillmentBadgeType } from "../../../../../../../utils/getOrderFulfillmentBadgeType";

export const FulfillmentTypeBadgeDraftBasket = ({
  fulfillmentType,
  isSupplier,
  estimatedDeliveryDate,
}: {
  fulfillmentType: OrderGetResponseType["fulfillmentType"] | null;
  isSupplier: boolean;
  estimatedDeliveryDate: Dayjs;
}) => {
  const fulfillmentTypeFormatted = getOrderFulfillmentBadgeType({
    fulfillmentType,
    isSupplier,
  });

  return (
    <Badge
      icon={"TRUCK"}
      className={"bg-gray-100 px-2 py-1 text-sm font-bold text-gray-700"}
    >
      {estimatedDeliveryDate.isValid()
        ? `${fulfillmentTypeFormatted}: ${estimatedDeliveryDate.format("ddd D MMM")}`
        : `${fulfillmentTypeFormatted}`}
    </Badge>
  );
};
